import React, { useState, useRef, useEffect } from "react";
import { edit_icon } from "../../../assets/imgs";
import { Table } from "../../../components/Table/Table";
import { alertList } from "../../redux/api/dummyJson";
import MultiSelectCheckbox from "../../../components/MultiSelectCheckbox";
import MultiSelectCheckboxSeverity from "../../../components/MultiSelectCheckboxSeverity";
const AlertIndTypes = ({
  editable,
  alertData,
  setAlertData,
  setSelected,
  selected,
  selectAlertTypes,
  btn,
  disable,
}) => {
  const [editIndex, setEditIndex] = useState(null);
  const [tempPriority, setTempPriority] = useState("");

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");

  // ref for inputs
  const inputRefs = useRef({});
  // console.log(editable, "editable");

  // Focus input automatically when editIndex changes
  useEffect(() => {
    if (editIndex !== null && inputRefs.current[editIndex]) {
      inputRefs.current[editIndex].focus();
    }
  }, [editIndex]);

  const handleChange = (event) => {
    const value = event.target.value;
    if (["1", "2", "3"].includes(value)) {
      setTempPriority(value);
    } else {
      setTempPriority("");
    }
  };

  const handleSave = (index) => {
    setAlertData((prev) => {
      const updated = [...prev];
      updated[index].priority = tempPriority || updated[index].priority;
      return updated;
    });
    setEditIndex(null);
    setTempPriority("");
  };

  const handleCancel = () => {
    setEditIndex(null);
    setTempPriority("");
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sNo",
        Cell: ({ row }) => <p>{(page - 1) * 10 + row.index + 1}</p>,
      },
      {
        Header: "Alert List",
        accessor: "alert",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Severity",
        accessor: "priority",
        Cell: ({ value, row }) => {
          const index = row.index;
          const isEditing = editIndex === index;

          return (
            <input
              className="input-box w-50 f4"
              type="text"
              value={isEditing ? tempPriority : value}
              onChange={(e) => isEditing && handleChange(e)}
              disabled={!isEditing}
              ref={(el) => {
                if (isEditing && el) el.focus();
              }}
            />
          );
        },
      },
      {
        Header: "Edit (priority count)",
        id: "edit",
        Cell: ({ row }) => {
          const index = row.index;
          return (
            <div className="d-flex gap-2">
              {editIndex === index ? (
                <>
                  <button
                    onClick={() => handleSave(index)}
                    className="save-btn"
                  >
                    Save
                  </button>
                  <button onClick={handleCancel} className="cancel-btn">
                    Cancel
                  </button>
                </>
              ) : (
                <button
                  onClick={() => {
                    setEditIndex(index);
                    setTempPriority(alertData[index].priority);
                  }}
                  className="cust-btn"
                >
                  <img src={edit_icon} alt="" className="edit-btn" />
                </button>
              )}
            </div>
          );
        },
      },
    ],
    [editIndex, tempPriority, alertData, page]
  );

  return (
    <div className="dashRightView ">
      <div className="d-flex ac-jb">
        {editable && (
          <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
            Total: {alertData.length}
          </h2>
        )}
      </div>

      {editable && (
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={alertData}
          show={true}
        />
      )}

      {!editable && (
        <>
          <div className="d-flex ac-jb gap-5">
            <MultiSelectCheckboxSeverity
              data={alertData}
              selected={selected}
              setSelected={setSelected}
              disable={disable}
            />
          </div>
          {disable ? null : (
            <button
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mx-3 my-5"
              onClick={() => selectAlertTypes()}
              disabled={btn}
            >
              submit
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default AlertIndTypes;
